import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableTab from "../components/tabs/table-tab";
import { PRESET_LOCKS } from "../constants/menu-types";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { Category } from "../models/Category";
import LockPresetColumns from "../models/ColumnDefinitions/LockPresetColumns";
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/HardwarePresetSearch';
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deletePreset, getLockPresets } from "../services/hardwarePresetService";
import { getSiteNamesWithPagination } from "../services/siteService";

interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void
}

const LockPresetsTab: FC<Props> = ({ setBusy, categories, setCategories }) => {
    const { translate } = useLocale()
    const title = translate.byKey(TranslationKeys.allLocks);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/hardware/lock-preset/';
    const LOCK_PRESET_TAB_POSITION = 5;

    useEffect(() => {
        setLookup([{
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        }]);
    }, [])

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deletePreset(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        const newCatergories: Category[] = categories.map((category) => {
                            return category.id === LOCK_PRESET_TAB_POSITION? { ...category, count: (category?.count ?? 1) - 1 } : category;
                        })
                        setCategories(newCatergories);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const initialiseUserPreferences = (setDetails: (userLoginId, PRESET_LOCKS) => void) => {
        setDetails(userLoginId, PRESET_LOCKS);
    }
    // <-- end context

    return <TableContextProvider
        dataMethod={getLockPresets}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={LockPresetColumns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        deleteMethod={onDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }}>
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath} 
            cyName="lockPresets"/>
    </TableContextProvider>
};

export default LockPresetsTab;
